export const transformResponse = (data, field="name") =>
  data.map(d => ({ text: d[field], value: d.token }))

export const publicProviderOrder = {
  "Blue Cross Blue Shield": 1,
  "UnitedHealthcare": 2,
  "Cigna": 3,
  "Other": 4,
  "Not Insured": 5,
}

export const sortProviders = (order, data) => {
  return data.sort((a, b) => (order[a.text] || data.length) - (order[b.text] || data.length))
}


// WEBPACK FOOTER //
// ./assets/dashboard/common.js